import React from "react";
import { FaInfoCircle } from "react-icons/fa";
import classes from './AlertBanner.css'

export default function AlertBanner({ message }) {
    return (
        <div className={[classes.alertBannerContainer].join(' ')} role="alert">
            <span className={classes.alertBannerIcon}>
                <FaInfoCircle color="#2196F3" fontSize="20px" />
            </span>
            <span className={classes.alertBannerMessage}>
                {message}
            </span>
        </div>
    );
};
